/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * from './getUploadLimits.defs'
export { main as default } from './getUploadLimits.defs'
